import React from 'react'

function Contact() {
  return (
    <div className='contact-container'>
        <div className="container">
            <div className="row" style={{marginTop:0}}>
                <div className="col-lg-6 credit">
                <p>All Rights Reserved ©️ <a href="https://rohanpranto.github.io">Rohan Biswas</a></p>
                </div>

                <div className="col-lg-6 social">
                    <p>
                        <a href="https://instagram.com/rohan.pranto"><i className='bx bxl-instagram'></i></a>
                        <a href="https://facebook.com/r.biswasz"><i className='bx bxl-facebook-square' ></i></a>
                        <a href="https://github.com/rohanpranto"><i className='bx bxl-github'></i></a>
                    </p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Contact
